import { Component } from '@angular/core';

@Component({
  selector: 'app-details-user',
  standalone: false,
  templateUrl: './details-user.component.html',
  styleUrl: './details-user.component.scss'
})
export class DetailsUserComponent {

}
